import { status } from "./status.js";
import { get } from "svelte/store";

//let languageIndex;

const textLines = {
    "Your session expired, please log in again": ["Su sesión ha expirado, por favor ingrese nuevamente al sistema"],
    "The ZofToken to test needs to be in the closed status": ["El ZofToken a probar debe estar en estado cerrado"],
    "Token successfully open": ["Token abierto exitosamente"],
    "Status refreshed": ["Estado actualizado"],
    "User opened the token under duress": ["El usuario abrió el token bajo coacción"],
    "Invalid response or user blocked": ["Respuesta inválida o usuario bloqueado"],
    "Copy succesful": ["Copia exitosa"],
    "My users": ["Mis usuarios"],
    "Your subscription has": ["Su subscripción tiene"],
    "users": ["usuarios"],
    "Search for a user": ["Buscar un usuario"],
    "Search for a service": ["Buscar un servicio"],
    "New user": ["Nuevo usuario"],
    "User name": ["Nombre de usuario"],
    "Service": ["Servicio"],
    "Status": ["Estado"],
    "Awaiting enrollment": ["Esperando enrolamiento"],
    "Open": ["Abierto"],
    "Closed": ["Cerrado"],
    "Under duress": ["Bajo coacción"],
    "Blocked": ["Bloqueado"],
    "REFRESHING": ["ACTUALIZANDO"],
    "This action cannot be undone. Are you sure?": ["Esta acción es definitiva. Está seguro?"],
    "Delete user": ["Borrar usuario"],
    "Admin": ["Administrar"],
    "Offline test": ["Prueba offline"],
    "Duplicate user": ["Usuario duplicado"],
    "Create user": ["Crear usuario"],
    "Cancel": ["Cancelar"],
    "User can scan this QR code to enroll their ZofToken": ["El usuario puede escanear este código QR para enrolar su ZofToken"],
    "Copy deeplink code": ["Copiar código deeplink"],
    "Close": ["Cerrar"],
    "Refresh status": ["Actualizar estado"],
    "You can update the status with the button above": ["Puede actualizar el estado con el botón de arriba"],
    "Force status change": ["Forzar cambio de estado"],
    "OPEN": ["ABRIR"],
    "CLOSE": ["CERRAR"],
    "BLOCK": ["BLOQUEAR"],
    "ENROLL": ["ENROLAR"],
    "Offline mode test": ["Modo prueba offline"],
    "Code Size": ["Largo del código"],
    "Has to be a multiple of 4 between 4 and 32": ["Debe ser un múltiplo de 4 entre 4 y 32"],
    "Challenge Code": ["Código Desafío"],
    "This is the code that needs to be sent to the user": ["Este es el código que debe ser enviado al usuario"],
    "User Response": ["Respuesta del Usuario"],
    "This is the code that the user gets in the ZofToken app": ["Este es el código que el usuario obtiene de la app ZofToken"],
    "Get challenge code": ["Obtener código desafío"],
    "Authenticate": ["Autenticar"],
    "Notification": ["Notificación"],
    "My services": ["Mis servicios"],
    "New service": ["Nuevo servicio"],
    "Delete service": ["Borrar servicio"],
    "View/Edit details": ["Ver/Editar detalles"],
    "Token active duration": ["Duración del token activo"],
    "Duress function": ["Funcionalidad de coacción"],
    "Basic Auth": ["Auth básico"],
    "Admin Auth": ["Auth administrativo"],
    "Create new service": ["Crear nuevo servicio"],
    "Duplicate service name": ["Nombre del servicio duplicado"],
    "All service names will use the subscription name as a prefix to ensure uniqueness.": ["Todos los nombres de servicio tendrán como prefijo el nombre de la subscripción para garantizar su unicidad."],
    "How long (in seconds) the token remains active after the user opens it.": ["Cuánto tiempo (en segundos) el token se mantiene activo luego de que el usuario lo abre."],
    "Enable duress function": ["Activar la funcionalidad de coacción"],
    "This selection can not be changed after creation.": ["Esta opción no puede ser cambiada luego de la creación del servicio."],
    "About this service": ["Acerca de este servicio"],
    "Configuration": ["Configuración"],
    "Logo": ["Logo"],
    "Friendly name to show the user so they can identify the service.": ["Nombre amigable para mostrar al usuario y facilitar la identificación del servicio."],
    "Service description": ["Descripción del servicio"],
    "A short description to show the user regarding the service": ["Un descripción corta del servicio para mostrar al usuario"],
    "Contact information for errors": ["Información de contacto en caso de errores"],
    "A short message to let the user know how they can access help (for example, dialing a telephone number) in case they have issues with their ZofToken.": ["Un mensaje corto para indicarle al usuario como obtener ayuda (por ejemplo, llamando a un número telefónico) en caso de tener problemas con su ZofToken."],
    "Offline mode description": ["Descripción del modo offline"],
    "A short message to let the user know how they should proceed (for example, dialing a telephone number) in case they need to authenticate through Offline Mode.": ["Un mensaje corto para indicarle al usuario como proceder (por ejemplo, llamando a un número telefónico) en caso de tener que utilizar su ZofToken en el modo offline."],
    "Parameters": ["Parámetros"],
    "Webhook host name": ["Nombre de servidor del webhook"],
    "Needs to be a host name with an optional port that can be accessed through HTTPS.": ["Debe ser un nombre de servidor con un número opcional de puerto que pueda ser accedido mediante HTTPS."],
    "Webhook secret": ["Secreto del webhook"],
    "This secret will be passed along in the webhook to verify it actually comes from the ZofToken server.": ["Este secreto será enviado junto con el webhook para verificar que el mismo viene efectivamente del servidor de ZofToken."],
    "Check the host certificate during the HTTPS connection": ["Verificar el certificado del servidor durante la conexión HTTPS"],
    "Should be turned off if you are using a self-signed or otherwise invalid certificate when receiving the webhook.": ["Debe estar deshabilitado si el servidor que recibe el webhook utiliza un certificado autofirmado o inválido por cualquier otro motivo."],
    "Test webhook": ["Probar el webhook"],
    "Save changes": ["Guardar cambios"],
    "Copy": ["Copiar"],
    "VIEW": ["VER"],
    "The service has active users, do you want to delete all users as well?": ["El servicio tiene usuarios activos, está seguro que también quiere borrarlos?"],
    "Are you sure you want to delete the service?": ["Está seguro que quiere borrar el servicio?"],
    "Session expired": ["Sesión expirada"],
    "Log in again": ["Ingresar nuevamente"],
    "Possible port error or firewalling issues?": ["Posible error de puerto o problemas de firewalling?"],
    "Connection timed out": ["Timeout de la conexión"],
    "Error connecting": ["Error en la conexión"],
    "Body returned:": ["Datos retornados:"],
    "Status code:": ["Código HTTP"],
    "Please open you administrative token in the ZofToken app and retry when ready": ["Por favor abra su token administrativo en la app ZofToken y reintente cuando esté listo"],
    "Open your token": ["Abra su token"],
    "Enabled": ["Activada"],
    "Disabled": ["Desactivada"],
    "Error": ["Error"],
    "OK": ["OK"],
    "Image file format must be PNG, and file size less than 100KB": ["El formato de la imagene debe ser PNG y el tamaño del archivo inferior a 100KB"],
    "Invalid file format": ["Formato de archivo inválido"],
    "Name": ["Nombre"],
    "Choose a file…": ["Seleccione un archivo…"],
    "Import": ["Importar"],
    "Copyright © 2024 ZofToken. All rights reserved.": ["Copyright © 2024 ZofToken. Todos los derechos reservados."],
    "Documentation": ["Documentación"],
    "Support": ["Soporte"],
    "Issues with ZaaS? Just complete this form and we will get back to you as soon as possible.": ["Problemas con ZaaS? Por favor complete este formulario y lo contactaremos lo antes posible."],
    "Submit": ["Enviar"],
    "Technical documentation": ["Documentación técnica"],
    "Subscription": ["Subscripción"],
    "My credentials": ["Mis credenciales"],
    "Delete subscription": ["Borrar subscripción"],
    "Log in": ["Iniciar sesión"],
    "Log out": ["Cerrar sesión"],
    "Get ZaaS for free!": ["Obtenga ZaaS gratis!"],
    "Password changed": ["Contraseña modificada"],
    "Wrong password or expired session, try again or log back in": ["Contraseña errónea o su sesión ha expirado, intente nuevamente o vuelva a ingresar al sistema"],
    "Are you sure? You will receive an email with your new enrollment data.": ["Está seguro? Recibirá un correo electrónico con la información para completar el nuevo enrolamiento."],
    "Your administrative ZofToken has been reset, you'll need to enroll it before you can log back in": ["Su ZofToken administrativo ha sido reiniciado, deberá volver a enrolarlo antes de poder ingresar al sistema"],
    "My credentials": ["Mis credenciales"],
    "Current password": ["Contraseña actual"],
    "You need to enter your password to do anything else in this page.": ["Debe ingresar su contraseña para poder hacer cualquier acción en esta página."],
    "Reset your administrative ZofToken": ["Reiniciar su ZofToken administrativo"],
    "Change your password": ["Cambiar su contraseña"],
    "New password": ["Nueva contraseña"],
    "Repeat the new password": ["Repetir la nueva contraseña"],
    "Passwords do not match": ["Las contraseñas no coinciden"],
    "Confirm deletion of your subscription, services and users": ["Confirme la eliminación de su subscripción, servicios y usuarios"],
    "Subscription deleted": ["Subscripción borrada"],
    "Warning": ["Advertencia"],
    "This will delete all users and services from this subscription rendering existing tokens inoperable": ["Esta acción eliminará todos los usuarios y servicios y cualquier token existente dejará de estar operativo"],
    "Type your subscription name to continue": ["Ingrese el nombre de su subscripción para continuar"],
    "You will also need your administrative ZoftToken to be open which will then be deleted": ["El ZofToken administrativo también deberá estar abierto y luego será eliminado"],
    "Delete": ["Borrar"],
    "Invalid credentials": ["Credenciales inválidas"],
    "Password reset email sent": ["Correo enviado para reinicializar la contraseña"],
    "No subscription exists with that email": ["No existe una subscripción con ese correo electrónico"],
    "Do not have an account?": ["No tiene una cuenta?"],
    "Sign up for free": ["Registrarse gratis"],
    "Email": ["Correo electrónico"],
    "Password": ["Contraseña"],
    "I forgot my password": ["Olvidé mi contraseña"],
    "Reset password": ["Reinicializar contraseña"],
    "Please enter your email address": ["Por favor ingrese su dirección de correo electrónico"],
    "Page not found": ["Página no encontrada"],
    "Notification": ["Notificación"],
    "Confirmation": ["Confirmación"],
    "You need to enroll your administrative ZofToken before accessing ZaaS": ["Debe enrolar su ZofToken administrativo antes de acceder a ZaaS"],
    "Privacy policy": ["Política de privacidad"],
    "Terms & conditions": ["Términos y condiciones"],
    "Be aware that your administrative ZofToken is currently closed and will need to be open to create a new service": ["Tenga en cuenta que su ZofToken administrativo se encuentra cerrado y deberá estar abierto para crear un nuevo servicio"],
    "Be aware that your administrative ZofToken is currently closed and will need to be open to change anything in the service": ["Tenga en cuenta que su ZofToken administrativo se encuentra cerrado y deberá estar abierto para introducir cualquier cambio al servicio"],
    "Subscription name": ["Nombre de la subscripción"],
    "Cannot be changed later": ["No podrá ser cambiado más adelante"],
    "Repeat password": ["Repita la contraseña"],
    "Already have an account?": ["Ya tiene una cuenta?"],
    "There are two additional steps required to finish setting up your subscription. After you receive the registration email:": ["Se requieren dos pasos adicionales para completar de configurar su subscripción. Luego de recibir el correo de registración:"],
    "Step 1": ["Paso 1"],
    "Click on the first link to confirm your registration.": ["Haga click en el primer link para confirmar su registro."],
    "Step 2": ["Paso 2"],
    "From your mobile, and after installing the ZofToken app, click on the second link in the email and then create your PIN to set up your administrative token.": ["Desde su celular, y luego de instalar la app de ZofToken, haga click en el segundo link del e-mail y luego cree su PIN para configurar su token administrativo."],
    "Registration successful": ["Registro exitoso"],
    "English": ["Inglés"],
    "Select language": ["Elija el idioma"],
    "Spanish": ["Español"],
    "Download app": ["Descargar la app"],
    "What is ZofToken as a Service (ZaaS)?": ["¿Qué es ZofToken como un servicio (ZaaS)?"],
    "Even though we generally discourage outsourcing your security, we offer most of ZofToken's features in our cloud environment, so you can easily create services and test your integrations, as well as, if it fits your business requirements, run your own 2FA solution as a service.": ["Si bien en general no recomendamos tercerizar su seguridad, ofrecemos la mayoría de la funcionalidad de ZofToken en nuestra plataforma basada en la nube, para que pueda crear servicios y probar sus integraciones en forma sencilla, asi como, si resulta compatible con sus requerimientos de negocio, operar su solución de 2FA como un servicio."],
    "What are the available features?": ["¿Qué funciones están disponibles?"],
    "The majority of features of the stand-alone version are available, including:": ["La mayoría de las funciones de la versión privada están disponibles, incluyendo:"],
    "Create an unlimited number of services": ["Crear una cantidad ilimitada de servicios"],
    "Manage all their configuration options": ["Administrar todas sus opciones de configuración"],
    "Create and manage users/tokens": ["Crear y administrar usuarios/tokens"],
    "Access token status through polling and webhooks": ["Acceder al estado de los tokens a través de consultas y webhooks"],
    "Pricing": ["Lista de precios"],
    "Basic": ["Básico"],
    "Enterprise": ["Empresarial"],
    "Custom": ["A medida"],
    "Up to 20 users": ["Hasta 20 usuarios"],
    "Unlimited services and configuration": ["Servicios y configuración ilimitados"],
    "Low priority support": ["Baja prioridad de soporte"],
    "Ideal for enthusiasts and internal use in small groups": ["Ideal para entusiastas y uso interno de grupos pequeños"],
    "Recommended for experiments and integration tests": ["Recomendado para experimentos y pruebas de integración"],
    "Tier 1": ["Tier 1"],
    "Up to": ["Hasta"],
    "price": ["precio"],
    "Tier 2": ["Tier 2"],
    "year": ["año"],
    "Contact us": ["Contáctenos"],
    "Fully managed cloud 2FA solution": ["Solución de 2FA cloud completamente administrada"],
    "High priority support": ["Alta prioridad de soporte"],
    "Ideal for internal use in low to mid-sized companies and external use for premium customers or business partners": ["Ideal para uso interno en compañías pequeñas y medianas y para uso externo con clientes premium o socios de negocio"],
    "For companies requiring higher numbers of users, a private": ["Para compañías que requieran volúmenes más altos de usuarios, se recomienda una instancia privada de"],
    "instance is the recommended approach as it will provide significantly cheaper costs and full autonomy": ["con costos significativamente inferiores y autonomía total"],
    "However, if you still prefer a managed solution, we can work with you to provide a custom design and pricing": ["Sin embargo, si de todos modos prefiere una solución administrada, podemos trabajar en conjunto para proveer un diseño y precio a medida"],
    "We are also open to discussing partnership or reseller agreements with service organizations that could add value to their customers through our solution": ["Asimismo, estamos abiertos a discutir acuerdos asociación o reventa con organizaciones de servicio que puedan agregar valor a sus clientes a través de nuestra solución"],
    "Succesful submission": ["Envio exitoso"],
    "This action cannot be undone and the user will have to enroll the token again. Are you sure?": ["Esta acción es definitiva y el usuario deberá enrolar su token nuevamente. Está seguro?"],
    "Reset token": ["Reinicializar token"],
    "ZofToken website": ["Sitio web de ZofToken"],
    "Retry": ["Reintentar"],
    "e.g. Can I enable the duress function after a service created?": ["e.g. Puedo activar la función de coacción luego de crear un servicio?"],
    "Be among the first to have access to our cloud services.": ["Sea de los primeros en acceder a nuestros servicios en la nube."],
    "First name": ["Nombre"],
    "Last name": ["Apellido"],
    "Company": ["Compañía"],
    "e.g. I want to schedule an online meeting to discuss the security details of ZofToken.": ["e.g. Quiero agendar una reunión online para discutir en detalle la seguridad de Zoftoken."],
    "Please provide your contact information and we will get back to you as soon as possible.": ["Por favor complete su información de contacto y nos comunicaremos con usted a la brevedad."]
};

export function tl(input) {
    let languageIndex = get(status).language;

    if (languageIndex == -1 || typeof textLines[input] == "undefined")
        return (input);
    else
        return (textLines[input][languageIndex]);
}

//languageIndex = get(status).language;
